<template>
    <el-dialog :visible="visible" width="384px" center custom-class="confirm-basic" :before-close="cancel">
        <span slot="title">
            <slot name="top-title"></slot>
        </span>
        <slot name="icon"></slot>
        <slot name="title"></slot>
        <div class="content"><slot></slot></div>
        <slot name="select"></slot>
        <span slot="footer">
            <slot name="op-btns"></slot>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        cancel() {
            this.$emit('closeConfirm');
        }
    }
}
</script>
<style>
.confirm-basic .el-dialog__body {
    padding: 35px 30px 30px;
}
    
.confirm-basic .el-dialog__footer {
    padding: 10px 30px 30px;
}
.confirm-basic .content {
    text-align: center;
}
.confirm-basic p {
    display: inline-block;
    margin: 0 auto;
    text-align: left;
}
.confirm-basic .title-dia {
    margin: 0;
    font-size: 18px;
    margin-bottom: 10px;
    color: #5C667E;
    font-weight: normal;
    text-align: center;
}
.confirm-basic .top-title {
    text-align: left;
    color: #5C667E;
    margin: 0;
}
.confirm-basic p {
    color: #9AA7C1;
}
.gray-pub-content {
    color: #9AA7C1;
}
.confirm-basic .op-btns .add:first-child {
    margin-right: 8px;
}
</style>





// WEBPACK FOOTER //
// src/components/Confirm.vue